export default __webpack_public_path__ + "static/media/office-video-itgirls.44ee592d.mp4";